import { h } from 'preact'
import { tagParser, proxymedia } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileEscda = ({ title, subtitle, image, alt, CTA: { URL, analytics, label } }) => {
   return (
      <a
         href={URL}
         {...attributesAnalytics(analytics)}
         class="tuile-escda lien-composite-before"
      >
         <div class="content">
            <img class="image mb-2" src={`${proxymedia(image, 'saveas=webp')}`} alt={alt || ''} loading="lazy" />
            <h3 class="h4 m-0 p-0">
               <strong class="title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
               <span class="subtitle" dangerouslySetInnerHTML={{ __html: tagParser(subtitle) }} />
            </h3>
         </div>
         <span class="o-link-arrow">{label}</span>
      </a>
   )
}
